// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"1ea3112c","541":"01fa1dff","777":"d62c120a"}[chunkId] + ".chunk.js";
};